import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Settings from 'src/Pages/Settings';
import { Suspender } from 'src/Suspender';
// import AIAgentPage from 'src/Pages/AIAgent/AIAgentPage';

// Lazy load all page components
const Campaigns = lazy(() => import('pages/Campaigns/List'));
const CampaignDetail = lazy(() => import('pages/Campaigns/Detail/CampaignDetail'));
const SessionsList = lazy(() => import('pages/Sessions'));
const CampaignsCreate = lazy(() => import('pages/Campaigns/Create/CampaignsCreate'));
const TranscriptList = lazy(() => import('src/Pages/Transcript/TranscriptList'));
const CreateSession = lazy(() => import('src/Pages/Sessions/CreateSession'));
const ManageSubscription = lazy(() => import('src/Pages/ManageSubscription/ManageSubscription'));

interface AuthRoute {
  path: string;
  component: React.ComponentType;
  aiEnabled?: boolean;
}

export const AUTHED_ROUTES: Record<string, AuthRoute> = {
  HOME: {
    path: '/',
    component: () => <Navigate to="/campaigns" replace />,
    aiEnabled: true
  },
  CAMPAIGNS: {
    path: '/campaigns',
    component: () => (
      <Suspender>
        <Campaigns />
      </Suspender>
    ),
    aiEnabled: true
  },
  SESSIONS: {
    path: '/sessions',
    component: () => (
      <Suspender>
        <SessionsList />
      </Suspender>
    ),
    aiEnabled: true
  },
  CREATE_CAMPAIGN: {
    path: '/campaigns/create',
    component: () => (
      <Suspender>
        <CampaignsCreate />
      </Suspender>
    ),
    aiEnabled: true
  },
  CAMPAIGN_DETAIL: {
    path: '/campaigns/:campaignId',
    component: () => (
      <Suspender>
        <CampaignDetail />
      </Suspender>
    ),
    aiEnabled: true
  },
  SESSION_TRANSCRIPT: {
    path: '/sessions/:sessionId/transcript',
    component: () => (
      <Suspender>
        <TranscriptList />
      </Suspender>
    ),
    aiEnabled: true
  },
  CREATE_SESSION: {
    path: '/campaigns/:campaignId/sessions/create',
    component: () => (
      <Suspender>
        <CreateSession />
      </Suspender>
    ),
    aiEnabled: true
  },

  SETTINGS: {
    path: '/settings',
    component: () => (
      <Suspender>
        <Settings />
      </Suspender>
    ),
    aiEnabled: false
  },

  MANAGE_SUBSCRIPTION: {
    path: '/manage-subscription',
    component: () => (
      <Suspender>
        <ManageSubscription />
      </Suspender>
    ),
    aiEnabled: false
  }
};
